export default __webpack_public_path__ + "static/media/Reconciliation-of-Share-Capital-Audit-Report.1b99b65f.pdf";